
export const MinWidthRequired = ({
    minWidth = 0
}) => {
    return (
        <div className="home">
            <div className="welcome">
                <div className="title">Oops...!</div>
                <div className="description" style={{ padding: 10 }}>
                    <p>
                        Modulen krever en bredde p&aring; mer enn {minWidth}px. <br />
                        Vennligst bruk iPad eller PC.
                    </p>
                </div>
            </div>
        </div>
    );
}
